import { render, staticRenderFns } from "./PayOver.vue?vue&type=template&id=2f8c4d45&scoped=true&lang=pug"
import script from "./PayOver.vue?vue&type=script&lang=js"
export * from "./PayOver.vue?vue&type=script&lang=js"
import style0 from "./PayOver.vue?vue&type=style&index=0&id=2f8c4d45&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8c4d45",
  null
  
)

export default component.exports